<template>
  <div class="d-flex px-5 py-3 container justify-content-center flex-column">
    <div>
      <meta-data-table v-if="currentJob.state === 'completed'" :first-file="currentJob.apiJob?.input[0]"
                       :second-file="currentJob.apiJob?.input[1]"></meta-data-table>
    </div>
    <div>
      <video-quality-factor-table v-if="metrics !== null" :pooled-metrics="metrics"></video-quality-factor-table>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import ViewJson from "../../Viewer/Json/ViewJson.vue";
import MetaDataTable from "../../Viewer/Compare/MetaDataTable.vue";
import VideoQualityFactorTable from "../../../../resultdisplay/VideoQualityFactorTable.vue";
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../events/job.events";
import axios from 'axios';

export default {
  name: "OutputCompareVideo",
  props: {},
  components: {VideoQualityFactorTable, MetaDataTable, ViewJson},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      metrics: null
    };
  },
  mounted: function () {
    if(this.currentJob.state === 'completed'){
      this.getMetrics()
    }
  },
  created: function () {
    EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
      axios.get(this.currentJob.apiJob.output[0].uri).then((response) => {
        this.metrics = response.data.pooled_metrics;
      });
    });
  },
  methods: {
    getMetrics(){
      axios.get(this.currentJob.apiJob.output[0].uri).then((response) => {
        this.metrics = response.data.pooled_metrics;
      });
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
</style>
